export enum Tool {
  DASHBOARD = 'DASHBOARD',
  CATALOG = 'CATALOG',
  CONFIGURATOR = 'CONFIGURATOR',
  SMART_MAP = 'SMART_MAP',
  INDEX = 'INDEX',
  ADDRESS_BOOK = 'ADDRESS_BOOK',
  ALIAS = 'ALIAS',
}
